import type {FilterProvider, MutableFilterBlock} from '@github-ui/filter-core'
import type {RefCallback} from 'react'

import {AddFilterButton} from './AddFilterButton'
import {AdvancedFilterItem} from './AdvancedFilterItem'
import styles from './FilterList.module.css'

interface FilterListProps {
  filterBlocks: MutableFilterBlock[]
  filterProviders: FilterProvider[]
  updateFilterBlock: (filterBlock: MutableFilterBlock) => void
  deleteFilterBlock: (index: number) => void
  isNarrowBreakpoint: boolean
  addFilterButtonMobileLastRowRef: React.RefObject<HTMLButtonElement | null>
  addNewFilterBlock: (provider: FilterProvider) => void
  registerQualifierButtonRef: (index: number) => RefCallback<HTMLButtonElement>
}

export const FilterList = ({
  filterBlocks,
  filterProviders,
  updateFilterBlock,
  deleteFilterBlock,
  isNarrowBreakpoint,
  addFilterButtonMobileLastRowRef,
  addNewFilterBlock,
  registerQualifierButtonRef,
}: FilterListProps) => {
  return (
    <div className={styles.Box_0}>
      <div className={styles.Box_1}>
        <div className={styles.Box_2} />
        <div className={styles.Box_3} />
        <span className={styles.Box_3}>Qualifier</span>
        <span className={styles.Text_0}>Operator</span>
        <span className={styles.Box_3}>Value</span>
        <div />
      </div>
      {filterBlocks.map((filterBlock, index) => (
        <AdvancedFilterItem
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={`advanced-filter-item-${index}`}
          filterBlock={filterBlock}
          filterProviders={filterProviders}
          updateFilterBlock={updateFilterBlock}
          index={index}
          deleteFilterBlock={deleteFilterBlock}
          qualifierButtonRef={registerQualifierButtonRef(index)}
        />
      ))}
      <div className={styles.Box_4}>
        <AddFilterButton
          size={isNarrowBreakpoint ? 'medium' : 'small'}
          ref={addFilterButtonMobileLastRowRef}
          filterProviders={filterProviders}
          addNewFilterBlock={addNewFilterBlock}
        />
      </div>
    </div>
  )
}
